import React, { Component } from "react";
import { Line } from "react-chartjs-2";
import "regenerator-runtime/runtime.js";
import Loader from 'components/loader';
import { GetSectionCustomizationOptions } from "components/util";

const CommonCustomizationOptions = GetSectionCustomizationOptions("CommonOptions");

function MakeOneChart(yvals, xvals, chartName, xlabel, ylabel) {
    const data = {
        labels: yvals,
        datasets: [{
            label: chartName,
            data: xvals,
            fill: false,
            backgroundColor: "rgba(75,192,192,0.2)",
            borderColor: "rgba(75,192,192,1)"
        }]
    };

    const options = {
        responsive: true,
        aspectRatio: 1.5,
        title: {
            display: true,
            text: chartName
        },
        tooltips: {
            mode: 'index',
            intersect: false,
        },
        hover: {
            mode: 'nearest',
            intersect: true
        },
        scales: {
            xAxes: [{
                display: true,
                scaleLabel: {
                    display: true,
                    labelString: xlabel
                }
            }],
            yAxes: [{
                display: true,
                scaleLabel: {
                    display: true,
                    labelString: ylabel
                }
            }]
        }
    };
    return {
        "data": data,
        "options": options
    }
}

/* function getCity(pathname) {
    // Given this.props.location.pathname, returns the first thing in the url, which is name of the city
    return (pathname.split('/').filter(word => word.length>0).slice(-1)[0])
}

function getState(pathname) {
    return (pathname.split('/').filter(word => word.length>0).slice(-1)[0])
}

function getYears(pathname) {
    return pathname.split("?years=").filter((word) => word.length > 0).slice(-1)[0];
} */

export default class NeighborhoodCharts extends Component {

    state = {
        loading: true,
        months: [],
        salesPriceData: [],
        salesPriceOptions: [],
        newListingData: [],
        newListingOptions: [],
        homesForSaleData: [],
        homesForSaleOptions: [],
        // City: this.props.City == null ? getCity(this.props.location.pathname) : this.props.City,
        // State: this.props.State == null ? getState(this.props.location.pathname) : this.props.State.toLowerCase(),
        // Years: this.props.Years == null ? getYears(this.props.location.pathname) : this.props.Years        
    };    

    async componentDidMount() {
        await this.loadData(this.props.State, this.props.City, this.props.Years);
    }

    async componentWillReceiveProps(nextProps) {
        if(this.props.State !== nextProps.State || this.props.City !== nextProps.City || this.props.Years !== nextProps.Years){
            await this.loadData(nextProps.State, nextProps.City, nextProps.Years);
        }
    }

    async loadData(state, city, years) {
        if(state && city && years){
            // const url = "https://graphapi.tlcengine.com/flaskRedirect/HPAPI"; 
            const url = CommonCustomizationOptions.CustomNeighborhoodChartsUrl;
            const response = await fetch(url + "/" + state.toLowerCase() + "/" + city + "/?years=" + years);
            const DATA = await response.json();
            const salesPrice = MakeOneChart(DATA.months, DATA.medianSalesPrice, "Median Sales Price", "Months", "Dollars");
            const newListing = MakeOneChart(DATA.months, DATA.newListingsPerMonth, "New Listings", "Months", "Listings");
            const homesForSale = MakeOneChart(DATA.months, DATA.homesForSale, "Homes for Sale", "Months", "Homes");
            this.setState({
                loading: false,
                salesPriceData: salesPrice.data,
                salesPriceOptions: salesPrice.options,
                newListingData: newListing.data,
                newListingOptions: newListing.options,
                homesForSaleData: homesForSale.data,
                homesForSaleOptions: homesForSale.options
            });
        }
    }
    
    render() {

        if (this.state.loading) {
            return (<div className="text-center"><Loader message={'Loading...'} /></div>);
        }
        
        return (
            <div>
                <Line data={this.state.salesPriceData} options={this.state.salesPriceOptions} />
                <Line data={this.state.newListingData} options={this.state.newListingOptions} />
                <Line data={this.state.homesForSaleData} options={this.state.homesForSaleOptions} />
            </div >
        );

    }
}